import { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import PricingPlan from "@/components/pricing/PricingPlan";
import { Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { useSubscription } from "@/hooks/useSubscription";

const PricingSection = () => {
  const { user } = useAuth();
  const [isAnnual, setIsAnnual] = useState(false);
  const { handleSubscribeMonthly, handleSubscribeAnnually } = useSubscription();

  const handleUpgradeClick = async () => {
    if (isAnnual) {
      await handleSubscribeAnnually();
    } else {
      await handleSubscribeMonthly();
    }
  };

  return (
    <section id="pricing" className="container mx-auto px-4 py-8 md:py-12">
      <div className="text-center mb-6">
        <h2 className="text-3xl sm:text-4xl font-bold mb-3">
          Pricing
        </h2>
        
        {/* Billing toggle */}
        <div className="flex flex-col items-center justify-center mb-6 gap-2">
          <div className="flex items-center justify-center gap-4">
            <span className={`text-sm font-medium transition-colors ${!isAnnual ? 'text-primary' : 'text-muted-foreground'}`}>
              Monthly
            </span>
            <Switch
              checked={isAnnual}
              onCheckedChange={setIsAnnual}
              aria-label={`Switch to ${isAnnual ? 'monthly' : 'annual'} billing`}
            />
            <span className={`text-sm font-medium transition-colors ${isAnnual ? 'text-primary' : 'text-muted-foreground'}`}>
              Annual
            </span>
          </div>
          {isAnnual && (
            <span className="text-xs bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-200 px-3 py-1 rounded-full font-medium">
              Save 53%
            </span>
          )}
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-4 md:gap-6 max-w-4xl mx-auto">
        <PricingPlan
          title="Free"
          price="Free"
          description=""
          features={[
            "1 Posit",
            "AI knowledge capture",
            "Unlimited chats & updates",
            "20% of your Posit revenue: after fees and applicable taxes",
            "Public Posit"
          ]}
          buttonText="Get Started Free"
          buttonLink={user ? "/dashboard/posits" : "/signup"}
          buttonDisabled={!!user}
          highlighted={false}
        />

        <PricingPlan
          title="Posit+"
          price={isAnnual ? "$45" : "$8"}
          period={isAnnual ? "/year" : "/month"}
          description={isAnnual ? "Billed annually" : "Billed monthly"}
          features={[
            "Everything in Free +",
            "10 Posits",
            "10% of your Posit revenue: after fees and applicable taxes",
            "Public, private, and exclusive Posits",
            "Analytics",
            "API, embedding, and custom url",
            "Access to affiliate program: earn 5% of revenue from your referrals for a year"
          ]}
          buttonText={user ? "Upgrade Now" : "Upgrade Now"}
          buttonLink={user ? "#" : "/signup?plan=plus"}
          onButtonClick={user ? handleUpgradeClick : undefined}
          highlighted={true}
          featureIcon={<Check className="h-5 w-5 text-primary mr-2 flex-shrink-0" />}
        />
      </div>
      

    </section>
  );
};

export default PricingSection;
